import { CustomerOriginType } from '../enums/CustomerOriginType';

export const CustomerOriginHelper = {

    typeToText: (type?: CustomerOriginType|null) => {
        switch (type) {
            case CustomerOriginType.Sislog:
                return 'Sislog';
            case CustomerOriginType.Shopify:
                return 'Shopify';
            case CustomerOriginType.Erp:
                return 'ERP';
            case CustomerOriginType.ManualRegistration:
                return 'Cliente';
            default:
                return 'Desconhecida';
        }
    },

}